/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountChild {
    getFixupPrototypeFunction() { return ServiceAccountChild.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountChild>): ServiceAccountChild {
        let obj = Object.assign(new ServiceAccountChild(), model);
        ServiceAccountChild.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountChild>): ServiceAccountChild {
        if (!model) return null;
        return ServiceAccountChild.newInstance(<ServiceAccountChild> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountChild) {
        if (!obj) return;

        models.ServiceAccountChild.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountChild): boolean {
        Object.setPrototypeOf(obj, ServiceAccountChild.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.native_details) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.native_details);
        }
    }

    /**
     * Native details of the account. This is a required field.
     */
    native_details: models.ServiceAccountNativeDetailsBase;

    /**
     * Number of child accounts.
     */
    count: number;

}
